import { useContext, useEffect, useState, useEffectEvent } from 'react';

import { SocketContext } from '../../socket/SocketProvider';
import useSnackbar from './useSnackbar';

const PRIVATE_MESSAGE = 'private-message';
const CHAT_MESSAGE = 'chat-message';

const notificationChime = new URL(
  '../../assets/notification-sound.mp3',
  import.meta.url,
).href;
const chime = new Audio(notificationChime);
const playChime = () => {
  chime.currentTime = 0;
  chime.play();
};

export default function useChatRoom() {
  const { socket } = useContext(SocketContext);

  const [socketMessages, setSocketMessages] = useState({});
  const [unreadMessages, setUnreadMessages] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);

  const { showSnackbarIfNotOnDashboard } = useSnackbar();

  const handlePrivateMessage = (msg) => {
    try {
      const { senderID, senderName, message } = JSON.parse(msg);
      setSocketMessages((prev) => {
        if (!(senderID in prev)) {
          return {
            ...prev,
            [senderID]: [{ senderName, senderID, message }],
          };
        }
        return {
          ...prev,
          [senderID]: [...prev[senderID], { senderName, senderID, message }],
        };
      });
      playChime();
      if (selectedUser === null || selectedUser.userID !== senderID) {
        setUnreadMessages((prev) => {
          if (!(senderID in prev)) {
            return {
              ...prev,
              [senderID]: 1,
            };
          }
          return {
            ...prev,
            [senderID]: prev[senderID] + 1,
          };
        });
      }
      showSnackbarIfNotOnDashboard(`${senderName} sent you a message.`);
    } catch (err) {
      console.error('Error handling private message:', err);
    }
  };

  const onPrivateMessage = useEffectEvent(handlePrivateMessage);

  useEffect(() => {
    socket.on(PRIVATE_MESSAGE, onPrivateMessage);
    return () => {
      socket.off(PRIVATE_MESSAGE, onPrivateMessage);
    };
  }, []);

  const emitMessage = (content) => {
    socket.emit(CHAT_MESSAGE, JSON.stringify(content));
  };

  return {
    emitterFns: { emitMessage },
    state: {
      selectedUser,
      socketMessages,
      unreadMessages,
    },
    setterFns: {
      setSelectedUser,
      setSocketMessages,
      setUnreadMessages,
    },
  };
}
